import React, { useEffect, useMemo, useRef, useState } from "react"
import TableContainer from "components/Common/TableContainer"
import moment from "moment"
import { Link } from "react-router-dom"
import eye from "../../../assets/images/icons/eye.svg"
import { UncontrolledTooltip } from "reactstrap"
import { getTableSortingHeaderIcon } from "helpers/common"
import { useLazyGetAllNotificationsQuery } from "store/api/investorapi/auth.api"
import { useReadNotificationMutation } from "store/api/user/user.api"
import useNotification from "hooks/useNotification"

const defaultFilters = {
  search: "",
  page: 1,
  pageSize: 20,
  timestamp: "",
}

const NotificationsTable = () => {
  const [getResults, { isFetching }] = useLazyGetAllNotificationsQuery()
  const [mutate] = useReadNotificationMutation()
  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([])
  const [count, setCount] = useState(0)
  const { reloadNotifications } = useNotification()

  //meta title
  document.title = "Notifications | Prachay"

  useEffect(() => {
    getList()
  }, [filters])

  const getList = async () => {
    try {
      const { data } = await getResults(filters).unwrap()
      setData(data?.rows)
      setCount(data?.count)
    } catch (e) {}
  }

  const onHandleReadNotification = async (item) => {
    if (!item.read) {
      try {
        const { success } = await mutate(item.id).unwrap()
        if (success) {
          getList()
          reloadNotifications()
        }
      } catch (err) {}
    }
  }

  const getTitleWithReadLabel = (item) => {
    return (
      <>
        {!item.read && (
          <p
            style={{
              marginBottom: "5px",
            }}
          >
            <span
              style={{
                padding: "2px 5px",
                borderRadius: "10px",
                color: "#fff",
                background: "#09518c",
                fontSize: "0.8em",
                marginRight: "2px",
              }}
            >
              Unread
            </span>
          </p>
        )}
        <div dangerouslySetInnerHTML={{ __html: item.title }} />
      </>
    )
  }

  const columns = useMemo(() => {
    const data = [
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, "Message"),
        accessorKey: "title",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <>
            <div
              className="mt-0 mb-1"
              style={{ maxWidth: "400px", whiteSpace: "normal" }}
            >
              {getTitleWithReadLabel(row.original)}
            </div>
          </>
        ),
      },
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, "Date"),
        accessorKey: "createdAt",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <>{moment(row.original.createdAt).format("D,MMM YYYY, HH:mm A")}</>
        ),
      },
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, "Action"),
        id: "role",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => {
          const editTooltip = `editTooltip-${row?.original.id}`

          return (
            <div className="d-flex justify-content-center align-items-center gap-3">
              <div className="action-view">
                <Link
                  to={row.original.url}
                  onClick={() => onHandleReadNotification(row.original)}
                >
                  <img src={eye} id={editTooltip} alt="" />
                  <UncontrolledTooltip placement="top" target={editTooltip}>
                    View
                  </UncontrolledTooltip>
                </Link>
              </div>
            </div>
          )
        },
      },
    ]

    return data
  }, [])

  return (
    <>
      <TableContainer
        isLoading={isFetching}
        count={count}
        filters={filters}
        setFilters={setFilters}
        columns={columns}
        data={data}
        isGlobalFilter={true}
        isCustomPageSize={true}
        // isGlobalFilter={true}
        isPagination={true}
        pagination="pagination"
        paginationWrapper="dataTables_paginate paging_simple_numbers"
        tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
      />
    </>
  )
}

export default NotificationsTable
